"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.dataExpression = exports.DataExpression = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _expressions = require("@wix/expressions");
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _wixExpressions = /*#__PURE__*/new WeakMap();
class DataExpression {
  static of(wixExpressions) {
    return new DataExpression(wixExpressions);
  }
  constructor(wixExpressions) {
    (0, _defineProperty2.default)(this, "initialize", async currency => {
      await _classPrivateFieldGet(_wixExpressions, this).loadExpressionFunctions(currency);
    });
    (0, _defineProperty2.default)(this, "evaluate", ({
      expression,
      variables
    }) => {
      const {
        evaluateExpression,
        getExpressionFunctions
      } = _classPrivateFieldGet(_wixExpressions, this);
      const value = evaluateExpression({
        expression,
        variables,
        functions: getExpressionFunctions()
      });
      return value;
    });
    _classPrivateFieldInitSpec(this, _wixExpressions, void 0);
    _classPrivateFieldSet(_wixExpressions, this, wixExpressions);
  }
}
exports.DataExpression = DataExpression;
const dataExpression = exports.dataExpression = DataExpression.of({
  loadExpressionFunctions: _expressions.loadExpressionFunctions,
  getExpressionFunctions: _expressions.getExpressionFunctions,
  evaluateExpression: _expressions.evaluateExpression
});
//# sourceMappingURL=data-expression.js.map